import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

interface SessionConfirmModalProps {
  onContinue: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export function SessionConfirmModal({ onContinue, onCancel, isLoading }: SessionConfirmModalProps) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex flex-col items-center text-center">
          <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mb-4">
            <AlertTriangle className="w-7 h-7 text-amber-600" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            {t('sessionWarning.title')}
          </h2>
          <p className="text-gray-600 text-sm mb-6 leading-relaxed">
            {t('sessionWarning.description')}
          </p>
          <div className="flex gap-3 w-full">
            <button
              onClick={onCancel}
              disabled={isLoading}
              className="flex-1 px-4 py-2.5 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors disabled:opacity-50"
            >
              {t('general.cancelButton')}
            </button>
            <button
              onClick={onContinue}
              disabled={isLoading}
              className="flex-1 px-4 py-2.5 rounded-lg bg-primary text-white font-medium hover:bg-secondary transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {isLoading && (
                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
              )}
              {t('sessionWarning.continueButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
